import script from "./users-no-results.vue?vue&type=script&setup=true&lang=ts"
export * from "./users-no-results.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__